export default __webpack_public_path__ + "static/media/main-logo.2870fb8d.png";